import useAPIErrors from "@/hooks/useAPIErrors";
import { UpdateWorkspace } from "@/api/workspace/types";
import { updateWorkspace as updateWorkspaceAPI } from "@/api/workspace/requests";
import { toast } from "sonner";

export const useGeneral = () => {
  const { handleErrors } = useAPIErrors();

  const updateWorkspace = async (params: UpdateWorkspace) => {
    const { response, errors } = await handleErrors(
      () => updateWorkspaceAPI(params),
      "Please check the form for errors."
    );

    if (!errors) {
      toast.success("Workspace updated successfully");
    }

    return response;
  };

  return {
    updateWorkspace,
  };
};
